import { Box, Typography } from '@/shared/ui';

import { Tag } from '@/shared/ui/primitives/Tag';

type SelectWidgetProps = {
  icon?: React.ReactNode;
  title: string;
  description?: string;
  onSelect: () => void;
  soon?: boolean;
  badge?: string;
  testId?: string;
  disabled?: boolean;
};

const SelectWidget = ({
  badge,
  icon,
  title,
  description,

  onSelect,
  soon = false,
  testId,
  disabled = false
}: SelectWidgetProps) => {
  const badgeLabel = soon ? 'Coming Soon' : badge;

  return (
    <Box
      data-testid={testId}
      sx={{
        backgroundColor: 'gx.tileDark',
        display: 'flex',
        gap: 1.5,
        padding: 2,
        cursor: soon || disabled ? 'default' : 'pointer',
        flexDirection: 'column',
        position: 'relative',
        opacity: disabled ? 0.4 : 1,
        pointerEvents: disabled ? 'none' : 'auto'
      }}
      onClick={soon || disabled ? () => {} : onSelect}
    >
      <Box
        data-testid='widget-icon'
        sx={{
          fontSize: '20px',
          display: 'flex',
          gap: 1,
          alignItems: 'center',
          flexWrap: 'wrap'
        }}
      >
        {icon}
        <Typography
          component='div'
          data-testid='widget-title'
          sx={{
            fontWeight: 700,

            gap: 2,
            display: 'inline-flex',
            alignItems: 'center'
          }}
        >
          {title}
        </Typography>
        {badgeLabel && (
          <Box
            data-testid={soon ? 'widget-soon' : 'widget-badge'}
            sx={{
              alignItems: 'center',
              display: 'inline-flex',
              flexShrink: 0,
              justifyContent: 'center',
              ml: 1
            }}
          >
            <Tag
              label={badgeLabel}
              sx={soon ? undefined : { minWidth: 'auto' }}
            />
          </Box>
        )}
      </Box>
      <Box>
        {description && (
          <Box
            data-testid='widget-description'
            sx={{ color: 'gx.subtext', fontSize: 14 }}
          >
            {description}
          </Box>
        )}
      </Box>
    </Box>
  );
};
export default SelectWidget;
